// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import Loading from '../../../../elements/Loading/Loading';
import AlertContainer from '../../../alert/container/AlertContainer';
import update from 'immutability-helper';
import Filter from '../../../../elements/Filter/Filter';
import { generateTags } from '../../../../elements/Filter/utils';
import OrderBox from '../OrderBox/OrderBox';
import classNames from 'classnames/bind';
import FilterDrawer from '../../../../elements/Filter/Drawer/FilterDrawer';
import AwardCounter from '../AwardCounter/AwardCounter';
import ProductsLimits from '../ProductsLimits/ProductsLimits';


import style from './FlightSales.scss';
import commonStyle from '../Flight.scss';
import icons from '../../../../assets/styles/icons.scss';
import filterOptionsStyle from '../../../../assets/styles/filter-options.scss';
import filterStyles from '../../../../assets/styles/filter.scss';

import type { LocalValuesState } from '../../../local-values/duck';
import type { Flight, Order } from '../../../../entities';
import type { Match } from '../../../../router';
import type { HTTPError } from '../../../../error';
import type { LocaleState } from '../../../locale/duck';
import type { FilterCheckbox } from '../../../../elements/Filter/Filter';
import type { TravelerReward } from '../../duck';

type Props = {
  +resetFlightSalesState: () => void;
  +localeState: LocaleState;
  +localValues: LocalValuesState;
  +flightSales?: Order[];
  +isFetchingSales?: boolean;
  +fetchFlightSales: (id: string) => void;
  +fetchSalesError?: HTTPError;
  +match: Match;
  +resetAlertState: () => void;
  +flight?: Flight;
  +fetchFlightTravelerReward: (id: string) => void;
  +isFetchingReward: boolean;
  +travelerReward: TravelerReward;
};

type State = {/*
  drawerOpen: boolean;
  filter: {
    name: {
      value: string;
    };
    openName: boolean;
    states: {
      [key: string]: boolean;
    };
    openStates: boolean;
  };
  sort: {
    value: string;
    name: string;
  };
  order: {
    value: 'ASC' | 'DESC';
  };
*/
};

const messages = defineMessages({
  title: {
    id: 'flight.sales.document.title',
  },
  description: {
    id: 'flight.sales.document.description',
  },
  // TODO: Ask how will this view sort
  /*sortPlaceholder: {
    id: 'sort.title',
  },
  sortClosestToDeliver: {
    id: 'sort.option.closestToDeliver',
  },
  sortFarthestToDeliver: {
    id: 'sort.option.farthestToDeliver',
  },
  sortHighestCommission: {
    id: 'sort.option.highestCommission',
  },
  sortLowestCommission: {
    id: 'sort.option.lowestCommission',
  },
  sortHighestTotalValue: {
    id: 'sort.option.highestTotalValue',
  },
  sortLowestTotalValue: {
    id: 'sort.option.lowestTotalValue',
  },*/
});

/*const initialState = {
  drawerOpen: false,
  filter: {
    name: {
      value: '',
    },
    openName: true,
    states: {},
    openStates: false,
  },
  sort: {
    value: '',
    name: '',
  },
  order: {
    value: 'DESC',
  },
};*/

export default class FlightSales extends Component<Props, State> {
  urlIdFlight: string;

  // state = initialState;

  constructor(props: Props) {
    super(props);
    if (props.match.params) this.urlIdFlight = props.match.params.id;
  }

  // Only in browser
  componentDidMount() {
    const { fetchFlightSales, flightSales, fetchFlightTravelerReward, travelerReward, flight } = this.props;
    if (!flightSales) {
      fetchFlightSales(this.urlIdFlight);
    }
    /*if (!travelerReward && !!flight) {
      fetchFlightTravelerReward(flight.id);
    }*/
  }

  componentDidUpdate = (prevProps: Props) => {
    const {
      fetchFlightTravelerReward, travelerReward, flight,
    } = this.props;

    /*if (!travelerReward && !prevProps.flight && !!flight) {
      fetchFlightTravelerReward(flight.id);
    }*/
  };

  componentWillUnmount() {
    const { resetFlightSalesState, resetAlertState } = this.props;
    resetFlightSalesState();
    resetAlertState();
  }

  /*handleOpenDrawer = () => {
    this.setState({ drawerOpen: true });
  };

  handleCloseDrawer = () => {
    const { fetchFlightSales } = this.props;
    this.setState({
      drawerOpen: false,
    });
    fetchFlightSales(this.urlIdFlight, this.buildQueryParams(), true);
  };

  handleChangeName(e: Event, isDesktop: boolean = true) {
    if (e.target instanceof HTMLInputElement) {
      const { value } = e.target;
      this.handleChangeFilterValueCreator(isDesktop)('name', { value });
    }
  }

  handleChangeState(e: Event, isDesktop: boolean = true) {
    const { filter } = this.state;
    if (e.target instanceof HTMLInputElement) {
      const { value } = e.target;
      this.handleChangeFilterValueCreator(isDesktop)('states', { [value]: !filter.stores[states] });
    }
  }

  buildQueryParams(): { [key: string]: any } {
    const params = {};
    const { filter, sort, order } = this.state;
    const states = Object.keys(filter.states)
      .reduce((acum, act: string) => filter.states[act] ? acum.concat(act) : acum, []);
    if (filter.name.value) {
      params.name = filter.name.value;
    }
    if (states.length) {
      params.states = states.join(',');
    }
    // Sort & Ord
    if (sort.name) {
      params.sort = sort.name;
    }
    if (order.value) {
      params.order = order.value;
    }
    return params;
  }

  handleChangeSort = (e: Event) => {
    const { fetchFlightSales } = this.props;
    if (e.target instanceof HTMLSelectElement) {
      const option = e.target.options[e.target.selectedIndex];
      const dataset: { sort: string, order: 'ASC' | 'DESC' } = (option.dataset: any);
      this.fireEvent();
      this.setState({
        sort: {
          value: option.value,
          name: dataset.sort,
        },
        order: {
          value: dataset.order,
        },
      }, () => fetchFlightSales(this.urlIdFlight, this.buildQueryParams(), true));
    }
  };

  handleClearFilters = () => {
    const { fetchFlightSales } = this.props;
    this.setState(initialState,
      () => fetchFlightSales(this.urlIdFlight, this.buildQueryParams(), true));
  };

  handleDeleteTag = (key?: string, name?: string) => {
    const { fetchFlightSales } = this.props;
    const updateQuery = {};
    switch (key) {
      case 'states':
        if (name) {
          updateQuery[key] = {
            [name]: { $set: false },
          };
        }
        break;
      case 'name':
        updateQuery[key] = {
          value: { $set: '' },
        };
        break;
    }
    this.setState((prevState: State) => update(prevState, {
      filter: updateQuery,
    }), () => fetchFlightSales(this.urlIdFlight, this.buildQueryParams(), true));
  };

  // Depends if desktop or mobile
  handleChangeFilterValueCreator = (isDesktop: boolean) =>
    (name: string, value: any) => {
      const { fetchFlightSales } = this.props;
      this.setState((state: State) => {
        const c = update(state.filter[name], { $merge: value });
        return {
          filter: update(state.filter, {
            [name]: { $set: c },
          }),
        };
      }, () => {
        if (isDesktop) {
          fetchFlightSales(this.urlIdFlight, this.buildQueryParams(), true);
        }
      });
    };

  handleOpen = (name: string) => {
    this.setState((state: State) => {
      return {
        filter: update(state.filter, {
          [name]: { $set: !state.filter[name] },
        }),
      };
    });
  };

  generateFilterFields = (states: ?FilterCheckbox[], { filter }: State, isDesktop: boolean) => [
    {
      type: 'text',
      titleIntl: 'filter.name.title',
      placeholderIntl: 'filter.name.placeholder',
      handler: (e: Event) => this.handleChangeName(e, isDesktop),
      stateValue: filter.name,
      name: 'name',
      icon: icons.symbolSearch,
      isOpen: filter.openName,
      handleOpen: () => this.handleOpen('openName'),
    },
    {
      type: 'checkbox',
      titleIntl: 'filter.states.title',
      handler: (e: Event) => this.handleChangeState(e, isDesktop),
      stateValue: filter.states,
      name: 'states',
      checkboxes: states,
      isOpen: filter.openStates,
      color: 'orange',
      handleOpen: () => this.handleOpen('openStates'),
    },
  ];*/

  render() {
    // const { drawerOpen, sort } = this.state;
    const { localValues, localeState, flightSales, isFetchingSales, flight, travelerReward, isFetchingReward } = this.props;
    /*const states: ?FilterCheckbox[] = [{
      label: 'dummyLabel',
      value: 'dummyValue',
    }];*/
    /*const filterFields = this.generateFilterFields(states, this.state, true);
    const filterContent =
      <Filter filterFields={(this.generateFilterFields(states, this.state, true): any)}
              handleDeleteTag={this.handleDeleteTag}/>;
    const tags: any = generateTags((filterFields: any), this.handleDeleteTag, this.context.intl.formatMessage);
    const sortNativeSelect = (
      <select value={sort.value}
              onChange={this.handleChangeSort}>
        <option value="closestToDeliver" data-sort="DELIVERY_DATE"
                data-order="DESC">{this.context.intl.formatMessage(messages.sortClosestToDeliver)}</option>
        <option value="farthestToDeliver" data-sort="DELIVERY_DATE"
                data-order="ASC">{this.context.intl.formatMessage(messages.sortFarthestToDeliver)}</option>
        <option value="highestCommission" data-sort="COMMISSION"
                data-order="DESC">{this.context.intl.formatMessage(messages.sortHighestCommission)}</option>
        <option value="lowestCommission" data-sort="COMMISSION"
                data-order="ASC">{this.context.intl.formatMessage(messages.sortLowestCommission)}</option>
        <option value="highestTotalValue" data-sort="TOTAL"
                data-order="DESC">{this.context.intl.formatMessage(messages.sortHighestTotalValue)}</option>
        <option value="lowestTotalValue" data-sort="TOTAL"
                data-order="ASC">{this.context.intl.formatMessage(messages.sortLowestTotalValue)}</option>
      </select>
    );*/

    const noResult = (!flightSales || !flightSales.length) && !isFetchingSales;

    const sales = flight && flightSales && flightSales
      .map((sale: Order, n: number) => <OrderBox key={n}
                                                 order={sale}
                                                 flight={flight}
                                                 localValues={localValues}
                                                 type='sale'/>);
    return (
      <Fragment>
        <Helmet>
          <title>{this.context.intl.formatMessage(messages.title)}</title>
          <meta name="description" content={this.context.intl.formatMessage(messages.description)}/>
        </Helmet>
        <section className={classNames(commonStyle.titleWrap, commonStyle.noFilters, {/*, commonStyle.mobile*/ })}>
          <i className={icons.iconBoxMedium}/> {/*TODO: update icon*/}
          <section className={commonStyle.content}>
            <FormattedMessage id="flight.sales.title">{
              txt => <h3 className={commonStyle.title}>{txt}</h3>
            }</FormattedMessage>
          </section>
        </section>
        {/*<section className={filterOptionsStyle.filterOptions}>
          <section className={filterOptionsStyle.header}>
            <FormattedMessage id="stores.filter.title">{
              text => <p className={filterOptionsStyle.title}><i className={icons.symbolTweak}/>{text}</p>
            }</FormattedMessage>
            <section className={classNames(commonStyle.titleWrap, commonStyle.desktop)}>
              <i className={icons.iconBoxMedium}/>
              <section className={commonStyle.content}>
                <FormattedMessage id="flight.requests.title">{
                  txt => <h3 className={commonStyle.title}>{txt}</h3>
                }</FormattedMessage>
              </section>
            </section>
            <section className={filterOptionsStyle.sortOptions}>
              <FormattedMessage id="sort.title">{
                txt => <label>{txt}</label>
              }</FormattedMessage>
              {sortNativeSelect}
            </section>
            <section className={filterOptionsStyle.filterDrawer}>
              <FilterDrawer drawerOpen={drawerOpen}
                            filterFields={(this.generateFilterFields(states,
                              this.state, false): any)}
                            color="orange"
                            handleCloseDrawer={this.handleCloseDrawer}
                            handleOpenDrawer={this.handleOpenDrawer}
                            handleClearFilters={this.handleClearFilters}/>
            </section>
          </section>
        </section>*/}
        <section className={commonStyle.mainWrap}>
          {/*<aside className={commonStyle.filterWrap}>
            {filterContent}
          </aside>*/}
          <section className={commonStyle.rightWrap}>
            <AlertContainer showId="flight"/>
            <section className={style.tabsWrap}>
              {false && localeState.domainCountry === 'PE' &&
              <article className={style.tab}>
                <AwardCounter isFetchingReward={isFetchingReward}
                              travelerReward={travelerReward}/>
              </article>}
              <article className={style.tab}>
                <ProductsLimits localeState={localeState}
                                isSale/>
              </article>
            </section>
            {(flight) && (
              <section className={style.downloadWrap}>
                <a href={`/v3/flight/${flight.id}/csv/orders`} target="_blank">Descargar resumen de pedidos</a>
              </section>
            )}
            {noResult &&
            <FormattedMessage id="flight.sales.noResults">{
              txt => <p className={style.noSales}>{txt}</p>
            }</FormattedMessage>}
            {/*{!!tags.length &&
            <ul className={filterStyles.tags}>
              {tags}
            </ul>}*/}
            <section className={style.salesWrap}>
              {sales}
            </section>
            {isFetchingSales && <Loading color="orange"/>}
          </section>
        </section>
      </Fragment>);
  }
}

FlightSales.propTypes = {
  resetFlightSalesState: PropTypes.func.isRequired,
  localeState: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  flightSales: PropTypes.array,
  isFetchingSales: PropTypes.bool,
  fetchFlightSales: PropTypes.func.isRequired,
  fetchSalesError: PropTypes.object,
  match: PropTypes.object.isRequired,
  resetAlertState: PropTypes.func.isRequired,
  flight: PropTypes.object,
  fetchFlightTravelerReward: PropTypes.func.isRequired,
  isFetchingReward: PropTypes.bool,
  travelerReward: PropTypes.object,
};

FlightSales.contextTypes = {
  intl: intlShape,
};




// WEBPACK FOOTER //
// ./src/modules/flight/components/FlightSales/FlightSales.jsx